import { gql } from '@apollo/client'

export default gql(`
query batchGetAuthors($input: [ID]) {
    batchGetAuthors(input: $input) {
      id
      name
    }
}`)
